module.exports = __webpack_public_path__ + "media/images/access-clubs-2ca16950e85d326296b9b45198ada5d5.svg";